import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from './rest.service';
import { FetchSchedulesPayload } from '../Inteface/fetch-schedules-payload';
import { ScheduleApiResponse } from '../Inteface/schedule-api-response';
import { ScheduleListReturnState } from '../Inteface/schedule-list-return-state';

export { FetchSchedulesPayload } from '../Inteface/fetch-schedules-payload';
export { ScheduleListItem } from '../Inteface/schedule-list-item';

export const SCHEDULE_LIST_RETURN_STATE_KEY = 'scheduleListReturnState';

export type ScheduleSearchMode = 'suiteName' | 'scheduleName';

@Injectable({
  providedIn: 'root'
})
export class ScheduleListService {

  constructor(private restService: RestService) { }

  fetchSchedules(payload: FetchSchedulesPayload): Observable<ScheduleApiResponse> {
    return this.restService.post('fetchSchedules', payload);
  }

  getScheduleById(scheduleId: string): Observable<any> {
    return this.restService.get('getScheduleById', scheduleId);
  }

  updateSchedule(scheduleId: string, payload: any): Observable<any> {
    return this.restService.put('updateSchedule', payload, scheduleId);
  }

  getCancellationWindow(scheduleId: string): Observable<any> {
    return this.restService.get('getScheduleCancellationWindow', scheduleId);
  }

  deleteSchedule(scheduleId: string): Observable<any> {
    return this.restService.delete('deleteSchedule', scheduleId);
  }

  saveListReturnState(state: ScheduleListReturnState): void {
    sessionStorage.setItem(SCHEDULE_LIST_RETURN_STATE_KEY, JSON.stringify(state));
  }

  consumeListReturnState(): ScheduleListReturnState | null {
    const raw = sessionStorage.getItem(SCHEDULE_LIST_RETURN_STATE_KEY);
    if (!raw) {
      return null;
    }
    sessionStorage.removeItem(SCHEDULE_LIST_RETURN_STATE_KEY);
    try {
      return JSON.parse(raw) as ScheduleListReturnState;
    } catch (e) {
      return null;
    }
  }

   /**
   * Immediately triggers a schedule execution (Run Now).
   * POST /schedules/{scheduleId}/run-now
   */
  runNow(scheduleId: string): Observable<any> {
    return this.restService.post('runScheduleNow', {}, scheduleId);
  }
  /**
   * Disables or resumes a schedule.
   * POST /schedules/{scheduleId}/status  body: { action: 'disable' | 'resume' }
   */
  updateScheduleStatus(scheduleId: string, action: 'disable' | 'resume'): Observable<any> {
    return this.restService.put('updateScheduleStatus', { action }, scheduleId);
  }
}
